import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "managepolicy-bucket" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "managepolicy-bucket" }
const _hoisted_4 = ["src"]

import { links } from "@/utils/Links";

//TODO url read from const file

export default /*@__PURE__*/_defineComponent({
  __name: 'FileAClaimModal',
  setup(__props) {

function openAssurantLink() {
  window.open(links.MY_ASSURANT_POLICY, "_blank");
}

function openNssiLink() {
  window.open(links.CUSTOMER_ACCOUNT_LOGIN, "_blank");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[10] || (_cache[10] = _createElementVNode("h4", null, "Manage Your Policy", -1)),
    _cache[11] || (_cache[11] = _createElementVNode("p", null, " To file a claim or manage your policy, visit the website of the appropriate insurer. ", -1)),
    _cache[12] || (_cache[12] = _createElementVNode("hr", null, null, -1)),
    _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _cache[2] || (_cache[2] = _createElementVNode("strong", null, "Renters Insurance", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("img", {
        src: require('@/assets/images/managepolicy-assurant.png'),
        style: {"max-width":"340px","width":"'100%'","height":"'auto'"},
        alt: "Manage Policy Assurant"
      }, null, 8, _hoisted_2),
      _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
      _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (openAssurantLink()))
      }, "My Assurant Policy")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[6] || (_cache[6] = _createElementVNode("strong", null, "Accidental Damage Personal Property Coverage", -1)),
      _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("img", {
        src: require('@/assets/images/managepolicy-nssi.png'),
        style: {"max-width":"260px","height":"'auto'"},
        alt: "Manage Policy NSSI"
      }, null, 8, _hoisted_4),
      _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
      _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (openNssiLink()))
      }, "NSSI Customer Area")
    ]),
    _cache[14] || (_cache[14] = _createElementVNode("div", { style: {"clear":"both"} }, null, -1))
  ], 64))
}
}

})